<template>
  <div>
    <b-card>
      <div class="row">
        <div class="col-lg-12">
          <h4>Új aggregátor létrehozása</h4>
        </div>
      </div>
    </b-card>
    <form-wizard
      ref="wizard"
      color="#3e74c7"
      :title="null"
      :subtitle="null"
      :enable-finish-button="true"
      layout="vertical"
      finish-button-text="Létrehozás"
      next-button-text="Tovább"
      next-button-icon="fa fa-arrow-right"
      back-button-text="Vissza"
      class="wizard-vertical mb-3"
      tabindex="3"
      @on-complete="create"
    >

      <!-- account datails tab -->
      <tab-content title="Aggregátor adatai">
        <div class="row">
          <h5 class="col-lg-12 mb-0 pb-0">
            Aggregátor adatai
          </h5>
          <b-form-group
            label="Megnevezés"
            label-for="name"
            class="col-md-12 mt-1"
          >
            <b-form-input
              id="name"
              v-model="name"
              type="text"
              placeholder="Megnevezés"
            />
          </b-form-group>
          <b-form-group
            label="Gyártó"
            label-for="brand"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="brand"
              v-model="brand"
              type="text"
              placeholder="Gyártó"
            />
          </b-form-group>
          <b-form-group
            label="Típus"
            label-for="type"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="type"
              v-model="type"
              type="text"
              placeholder="Típus"
            />
          </b-form-group>
          <b-form-group
            label="Gyári szám"
            label-for="manufacturing_number"
            class="col-md-4 mt-1"
          >
            <b-form-input
              id="manufacturing_number"
              v-model="manufacturing_number"
              type="text"
              placeholder="Gyári szám"
            />
          </b-form-group>
          <b-form-group
            label="Üzemóra"
            label-for="operating_hours"
            class="col-md-6 mt-1"
          >
            <b-form-input
              id="operating_hours"
              v-model="operating_hours"
              type="number"
              placeholder="Üzemóra"
            />
          </b-form-group>
          <b-form-group
            label="Szervíz intervallum"
            label-for="service_interval"
            class="col-md-6 mt-1"
          >
            <b-form-input
              id="service_interval"
              v-model="service_interval"
              type="number"
              placeholder="Szervíz intervallum"
            />
          </b-form-group>
        </div>

      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BFormGroup,
  BFormInput,
  BCard,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BFormGroup,
    BFormInput,
    BCard,
  },
  data() {
    return {
      name: '',
      brand: '',
      type: '',
      manufacturing_number: '',
      operating_hours: '',
      service_interval: '',
    }
  },
  methods: {
    create() {
      axios({
        method: 'post',
        url: 'aggregator/create',
        data: {
          name: this.name,
          brand: this.brand,
          type: this.type,
          manufacturing_number: this.manufacturing_number,
          operating_hours: this.operating_hours,
          service_interval: this.service_interval,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres létrehozás!',
            text: 'Az aggregátor sikeresen létrehozva.',
            variant: 'success',
          },
        })
        this.$router.push(`/aggregators/edit/${response.data.id}`)
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba történt!',
            text: 'Az aggregátor létrehozása sikertelen.',
            variant: 'danger',
          },
        })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
</style>
